/**
 * Id da credencial de biometria deste aparelho, por usuário, enviado no login para vincular a
 * sessão. Não é segredo (identificador público da credencial) e não autentica nada sozinho.
 * Storage indisponível (modo privado, bloqueado) degrada para "sem id": o login sai sem vínculo.
 */
const STORAGE_KEY = 'pc-biometria'

type Mapa = Record<string, string>

const chave = (nomeUsuario: string) => nomeUsuario.trim().toLowerCase()

function ler(): Mapa {
  try {
    const bruto = localStorage.getItem(STORAGE_KEY)
    const mapa: unknown = bruto ? JSON.parse(bruto) : {}
    return mapa && typeof mapa === 'object' ? (mapa as Mapa) : {}
  } catch {
    return {}
  }
}

function gravar(mapa: Mapa) {
  try {
    if (Object.keys(mapa).length === 0) localStorage.removeItem(STORAGE_KEY)
    else localStorage.setItem(STORAGE_KEY, JSON.stringify(mapa))
  } catch {
    /* storage indisponível: o próximo login sai sem vínculo e o app oferece o cadastro */
  }
}

export const credencialLocal = {
  obter: (nomeUsuario: string): string | undefined => ler()[chave(nomeUsuario)],
  guardar: (nomeUsuario: string, credencialId: string) =>
    gravar({ ...ler(), [chave(nomeUsuario)]: credencialId }),
  apagar: (nomeUsuario: string) => {
    const { [chave(nomeUsuario)]: _removido, ...resto } = ler()
    gravar(resto)
  },
}
